import { Splide } from "@splidejs/splide";

document.addEventListener('alpine:init', () => {
    Alpine.data('newsTeaser', () => ({

        splide: null,
        splideOptions: {
            type: "fade",
            drag: false,
            arrows: false,
            isNavigation: false,
            pagination: false,
        },
        navigation: null,
        navigationOptions: {
            drag: false,
            rewind: true,
            fixedWidth: "25%",
            autoplay: true,
            interval: 7000,
            isNavigation: true,
            pagination: false,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            breakpoints: {
                767: {
                    fixedWidth: 220,
                    drag: true,
                    focus: "center",
                },
            },
        },
        activeBar: null,

        init() {
            this.splide = new Splide(this.$refs.slider, this.splideOptions);
            this.navigation = new Splide(this.$refs.nav, this.navigationOptions);
            this.splide.sync(this.navigation);
            this.splide.mount();
            this.navigation.mount();
            const splideSelector = this.$refs.container.querySelector("#splide02-slide01");
            if (splideSelector) {
                this.activeBar = splideSelector.querySelector(".splide__progress__bar");
            }
            this.navigation.on("active", (Slide) => {
                this.activeBar.style.width = `0%`;
                this.activeBar = Slide.slide.querySelector(".splide__progress__bar");
            });
            this.navigation.on("autoplay:playing", (rate) => {
                if (this.activeBar) {
                    this.activeBar.style.width = `${rate * 100}%`;
                }
            });
        },
    }));
});
